import { Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { useSession } from './hooks/session';
import { Button, Spinner } from './components/ui';
import { AnalyticsPage } from './pages/AnalyticsPage';
import { BillingPage } from './pages/BillingPage';
import { ChecklistPage } from './pages/ChecklistPage';
import { FeedPage } from './pages/FeedPage';
import { NoAccessPage } from './pages/NoAccessPage';
import { OnboardingPage } from './pages/OnboardingPage';
import { ReviewPage } from './pages/ReviewPage';
import { AccountsPage } from './pages/AccountsPage';
import { SettingsPage } from './pages/SettingsPage';
import { ReplySettingsPage } from './pages/ReplySettingsPage';
import { NotificationsPage } from './pages/NotificationsPage';
import { TeamPage } from './pages/TeamPage';

export function App() {
  const session = useSession();

  if (session.status === 'loading') {
    return (
      <div className="flex min-h-full items-center justify-center">
        <Spinner size={28} />
      </div>
    );
  }

  if (session.status === 'error') {
    return (
      <div className="flex min-h-full flex-col items-center justify-center gap-4 px-8 text-center">
        <div className="text-4xl" aria-hidden="true">😕</div>
        <p className="text-[15px] text-[var(--color-hint)]">{session.error}</p>
        <Button onClick={() => void session.refresh()}>Повторить</Button>
      </div>
    );
  }

  /*
   * Без организации возможны два случая: администратор с ключом идёт в мастер
   * настройки, остальные видят экран «нет доступа» с кнопкой запроса.
   */
  if (!session.activeOrganizationId) {
    const entry = session.canCreateOrganization ? <OnboardingPage /> : <NoAccessPage />;
    return (
      <Routes>
        <Route path="/onboarding" element={entry} />
        <Route path="*" element={<Navigate to="/onboarding" replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/feed" element={<FeedPage />} />
        <Route path="/analytics" element={<AnalyticsPage />} />
        <Route path="/checklist" element={<ChecklistPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/settings/replies" element={<ReplySettingsPage />} />
        <Route path="/settings/notifications" element={<NotificationsPage />} />
        <Route path="/settings/accounts" element={<AccountsPage />} />
        <Route path="/settings/team" element={<TeamPage />} />
        <Route path="/settings/billing" element={<BillingPage />} />
        <Route path="/feed/:reviewId" element={<ReviewPage />} />
      </Route>
      <Route path="/onboarding" element={<Navigate to="/feed" replace />} />
      <Route path="*" element={<Navigate to="/feed" replace />} />
    </Routes>
  );
}
